module.exports = __webpack_public_path__ + "models/camera_96af8974903687f7566b88c18573423f.glb";